import { render, staticRenderFns } from "./DomPlane.vue?vue&type=template&id=e7efddba&"
import script from "./DomPlane.vue?vue&type=script&lang=js&"
export * from "./DomPlane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports